<template>
	<el-row class="HBC-el-row">
		<el-col :span="24">
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="ishavePm && !ishavecm && !ishavec2m && !ishavec3m">
				<el-breadcrumb-item :to="{ path: '/console' }">控制台</el-breadcrumb-item>
				<el-breadcrumb-item >{{ PMname }}</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="ishavePm && ishavecm && !ishavec2m && !ishavec3m">
				<el-breadcrumb-item :to="{ path: '/console' }">控制台</el-breadcrumb-item>
				<el-breadcrumb-item >{{ PMname }}</el-breadcrumb-item>
				<el-breadcrumb-item >{{ CMname }}</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="ishavePm && ishavecm && ishavec2m && !ishavec3m">
				<el-breadcrumb-item :to="{ path: '/console' }">控制台</el-breadcrumb-item>
				<el-breadcrumb-item >{{ PMname }}</el-breadcrumb-item>
				<el-breadcrumb-item >{{ CMname }}</el-breadcrumb-item>
				<el-breadcrumb-item >{{ C2Mname }}</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="ishavePm && ishavecm && ishavec2m && ishavec3m">
				<el-breadcrumb-item :to="{ path: '/console' }">控制台</el-breadcrumb-item>
				<el-breadcrumb-item >{{ PMname }}</el-breadcrumb-item>
				<el-breadcrumb-item >{{ CMname }}</el-breadcrumb-item>
				<el-breadcrumb-item >{{ C2Mname }}</el-breadcrumb-item>
				<el-breadcrumb-item >{{ C3Mname }}</el-breadcrumb-item>
			</el-breadcrumb>
		</el-col>
	</el-row>
</template>
<script>
	export default {
		name: 'Hrrbreadcrumb',
		props:{
			PMname: {
				type:String,
				default:""
			},
			CMname: {
				type:String,
				default:""
			},
			C2Mname:{
				type:String,
				default:""
			},
			C3Mname:{
				type:String,
				default:""
			}
		},
		computed: {
			ishavePm: function () {
				return this.PMname!="";
			},
			ishavecm: function () {
				return this.CMname!="";
			},
			ishavec2m: function () {
				return this.C2Mname!="";
			},
			ishavec3m: function () {
				return this.C3Mname!="";
			}
		}
	}
</script>
<style>
.HBC-el-row{ width: 100%; height: 50px;background-color: #FFF; padding: 0 15px;}
.HBC-el-row *{line-height: 50px;}
.el-breadcrumb{width: 100%;}
</style>
